<template>
  <div class="view">
    <Title title="お知らせ"/>
    <InfoEditMain />
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import InfoEditMain from '@/components/Info/EditMain'

export default {
  components: {
    Title,
    InfoEditMain
  }
}
</script>
